// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__jdxqw","imageUploader":"EGiftCard_imageUploader__2EgzI"};